<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { useModel } from '../model/model'
import { useRouter } from 'vue-router'
import { useLogout } from '../model/api'
import { useAuth } from '@/entities/Auth'

const { menuList } = useModel()
const { logout, isPending } = useLogout()
const router = useRouter()
const auth = useAuth()

const clickHandler = (link: string) => router.push(link)
</script>

<template>
  <a href="#" class="w-user__btn" @click.prevent>
    <VIcons type="account_circle" />

    <VMenu activator="parent">
      <VList>
        <VListItem>
          <VListItemTitle>{{ auth.user?.login }}</VListItemTitle>
        </VListItem>

        <VListItem
          v-for="menu in menuList"
          :key="menu.name"
          :value="menu.link"
          @click="clickHandler(menu.link)"
        >
          <VListItemTitle>
            {{ $t(menu.name) }}
          </VListItemTitle>
        </VListItem>

        <VListItem value="logout" :disabled="isPending" @click.prevent="logout">
          <VListItemTitle>{{ $t('itf.logout') }}</VListItemTitle>
        </VListItem>
      </VList>
    </VMenu>
  </a>
</template>
